
// This is an auto generated file - do not edit!
// Swagger path: /api/License

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    LicenseInfo
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class LicenseApiService extends BaseApiService {
    
    get(options = {}): Observable<LicenseInfo> {
        return this._get<LicenseInfo>(
            `/License`,
            options
        );
    }
}
